module.exports = __webpack_public_path__ + "media/images/sp/page_common/keywords/keyword_shrines_temples-cf7d3fba8f53c9eb08e53bf42a9fc212.jpg";